import styled from 'styled-components';

export const InputContainer = styled.div`
  width: 100%;
  text-align: left;
`;

export const InputContent = styled.div<{ variant?: 'outlined' | 'filled' }>`
  display: flex;
  gap: 12px;
  align-items: center;
  border: 1px solid #ad9552;
  border-radius: 2px;
  padding: 0 8px;
  position: relative;
  margin-top: 4px;

  ${props =>
    props.variant === 'outlined' &&
    `
    background-color: transparent;
    border: none;
    border-bottom: 1px solid #ad9552;
  `}
`;

export const InputIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const VisibleInputIcon = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const InputStyled = styled.input<{
  isValid?: boolean;
  theme?: 'light' | 'dark';
  variant?: 'outlined' | 'filled';
}>`
  width: 100%;
  height: 40px;
  border-radius: 2px;
  color: ${props => (props.theme === 'light' ? '#0c0c0c' : '#FFFFFF')};
  box-sizing: border-box;
  font-size: 16px;
  border: none;

  &:hover,
  &:focus,
  &:active {
    outline: none;
    box-shadow: none;
    border: none;
  }

  ${props =>
    props.variant === 'outlined' &&
    `
    background-color: transparent;
  `}

  ::placeholder {
    color: #8f8f8f;
    font-size: 16px;
  }
`;

export const HelperText = styled.div`
  margin-top: 8px;
`;

export const CurrencyPrefix = styled.span<{ theme?: 'light' | 'dark' }>`
  color: ${props => (props.theme === 'light' ? '#0c0c0c' : '#FFFFFF')};
  font-size: 16px;
  user-select: none;
`;
